import { compareTimes } from './compareTimes'

/**
 * Checks if an offer is available today based on weekday schedules
 * @param {Array<{day: string, enabled: boolean, start_time: string|null, end_time: string|null}>} weekdaySchedules
 * @param {string} currentDay - lowercase weekday, e.g., 'monday'
 * @returns {boolean} true if offer is enabled for today and current time is within range
 */
export function isOfferAvailable(weekdaySchedules, currentDay) {
  // No schedules => always available
  if (!Array.isArray(weekdaySchedules) || weekdaySchedules.length === 0) {
    return true
  }

  // Check if ANY weekday is enabled at all
  const hasAnyEnabledWeekday = weekdaySchedules.some((w) => w.enabled === true)

  // If NO weekday is enabled (all are false or not set), then visible everyday
  if (!hasAnyEnabledWeekday) {
    return true
  }

  // Find today's schedule
  const todaySchedule = weekdaySchedules.find(
    (w) => w.day.toLowerCase() === currentDay.toLowerCase(),
  )

  // If today has no schedule defined, but some other days are enabled
  // This means today should be disabled (visible only on explicitly enabled days)
  if (!todaySchedule) {
    return false
  }

  // If today is explicitly disabled, hide the offer
  if (!todaySchedule.enabled) {
    return false
  }

  // If today is enabled, check start/end times (optional)
  if (todaySchedule.start_time && todaySchedule.end_time) {
    return compareTimes(todaySchedule.start_time, todaySchedule.end_time)
  }

  return true
}
